import { useAdminGet } from '@reapitform/hooks'
import { MergeFieldModel } from '../types'

export const ADMIN_MERGE_FIELDS_QUERY_KEY = ['admin-merge-fields']

/** Loads the merge-field catalog (`GET /api/merge-fields`) for the field default-value picker. */
export const useAdminMergeFields = () => {
  const [data, loading, errorString, refresh] = useAdminGet<MergeFieldModel[]>({
    path: '/api/merge-fields',
    retry: false,
    queryKeys: ADMIN_MERGE_FIELDS_QUERY_KEY,
    fetchWhenTrue: [true],
  })

  return { data, loading, errorString, refresh }
}
